import React, { memo, useEffect, useRef, useState } from 'react';
import Card from '../components/Card';
import SpeakerDoc from './SpeakerDoc';
import { Swiper, SwiperSlide } from 'swiper/react';
import LazyImage from '../../CustomLibraries/LazyImage';
import { clinical_Video_static_image } from '../../../common/assets.common';
import ReactPlayer from 'react-player';
import InView, { useInView } from 'react-intersection-observer';
import { isMobile } from 'react-device-detect';
import useRedirect from '../../customHooks/useRedirect';
import useShare from '../../customHooks/useShare';
import { useAddLike } from '../../../Queries/QueryHooks/clvideo.hook';
import ReportContentPopover from './components/ReportContentPopover';
import { removeHtmlTags } from '../../../pages/channel/utils';
import { useTrackUserActivity } from '../../customHooks/useTrackUserActivity';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import TooltipContainer from '../components/TooltipContainer';

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 *
 */
const ClinicalVideosCard = (data) => {
  const {
    type = '',
    className = '',
    click,
    sponsorLogo,
    sessionDoctorEntities,
    playTime,
    id,
    question,
    src,
    specialities,
    deeplink,
    moduleType,
    image,
    likeCount,
    commentCount,
    viewCount,
    specialities_ids_and_names,
    featured = false,
    contentType
  } = data || {};
  const share_url = useShare();
  const { userActivityTracker } = useTrackUserActivity();

  const sponsor_logo = sponsorLogo ? sponsorLogo.split(',') : [];
  const sessionDoctorDetails = sessionDoctorEntities ?? [];
  const [showVideo, setShowVideo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [videoRendered, setVideoRendered] = useState(false);
  const [clVideoref, inView] = useInView({
    fallbackInView: false,
    threshold: 0
  });
  const videoDetailsParent = useRef();
  const [aspectVideoContainerSize, setAspectVideoContainerSize] = useState('0px');
  const playerRef = useRef();
  const { redirectTo } = useRedirect();
  const onReady = React.useCallback(() => {
    if (playTime) {
      const timeToStart = playTime;
      playerRef.current.seekTo(timeToStart, 'seconds');
    }
  }, [playerRef.current]);
  const cardClick = () => {
    click ? click() : redirectTo('ClinicalVideoDetails', id, question);
  };
  const setVideoConatinerSize = () => {
    if (videoDetailsParent.current) {
      const videoDivWidth = videoDetailsParent.current ? videoDetailsParent.current.clientWidth : 0;
      const aspectWidth = videoDivWidth / 1.7786;
      setAspectVideoContainerSize(aspectWidth > 0 ? Math.round(aspectWidth) : 0);
    }
  };
  const handleVideoShow = () => {
    setLoading(true);
    setShowVideo(true);
    setTimeout(() => {
      setShowVideo(false);
      setVideoRendered(false);
    }, 30000);
  };
  const handleVideoClose = () => {
    setShowVideo(false);
    setLoading(false);
    setVideoRendered(false);
  };
  useEffect(() => {
    if (isMobile && !inView) {
      handleVideoClose();
    }
  }, [inView]);
  function format(seconds) {
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = pad(date.getUTCMinutes());
    const ss = pad(date.getUTCSeconds());
    if (hh) {
      return `${hh}:${mm}:${ss}`;
    }
    return `${mm}:${ss}`;
  }

  function pad(string) {
    return ('0' + string).slice(-2);
  }
  const handleStart = () => {
    setLoading(false);
    setVideoRendered(true);
  };

  const onLikePress = () => {
    saveLike({ type: 'video_archive', type_id: id });
  };

  // HOOKS
  const { mutate: saveLike } = useAddLike('video_archive', id);
  const specialityClick = () => {
    if (specialities_ids_and_names?.length > 0) {
      let { master_specialities_id, specialities_name } = specialities_ids_and_names[0];
      redirectTo('Speciality', master_specialities_id, specialities_name);
    }
  };

  // useEffect(() => {
  //   if (inView && sponsor_logo && sponsor_logo.length > 0) {
  //     console.log('event Trigger');
  //     opix('event', 'session', { type_id: id });
  //   }
  // }, [sponsor_logo, inView]);

  return (
    <Card
      ref={clVideoref}
      className={`clr_v3_card__clinicalVideos ${className ?? ''} ${loading ? 'loadPlayer' : ''}  ${
        featured && 'clr_v3_card__featured'
      }`}
      type={type}
    >
      {featured && (
        <span className="clr_v3_card__featured__tag bg-primary rounded-pill position-absolute text-white">
          <i className="clr_v3_card__featured__icon translate-middle start-50 top-50 position-absolute">
            <i className="flaticon-danger fs-1"></i>
          </i>
        </span>
      )}
      <Card.Body>
        <Card.Header>
          {/* {specialities && (
            <span className="clr_v3_card__icon d-inline-flex align-items-center justify-content-center me-auto cursorPointer">
              <span onClick={specialityClick}>{specialities?.split(',')[0]}</span>
              {specialityPopOver(specialities)}
            </span>
          )} */}
          {contentType && (
            <span className="clr_v3_card__icon d-inline-flex align-items-center justify-content-center me-auto cursorPointer gap-2">
              <i className="flaticon-clinicalvideo fs-2 text-primary"></i>
              <span>{contentType}</span>
            </span>
          )}
          <InView
            as="div"
            className="ms-auto align-items-center d-flex gap-sm-3 gap-2"
            onChange={(inView) => {
              userActivityTracker(inView, { ...data, type: 'archived_video', type_id: id }, 'card');
            }}
          >
            {question ? (
              deeplink ? (
                <TooltipContainer text="Share">
                  <span
                    className="icon-size-32 icon-size-sm-36 clr_v3_card__icon transition cursorPointer flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill rippleEffect position-relative fs-2 clr_v3_icon-btn-1"
                    onClick={() => {
                      share_url(question, deeplink);
                    }}
                  >
                    <i class="flaticon-share"></i>
                  </span>
                </TooltipContainer>
              ) : (
                <></>
              )
            ) : (
              <></>
            )}
            {/* <i class="flaticon-more-1 fs-1"></i> */}
            <ReportContentPopover type={moduleType} id={id} />
          </InView>
        </Card.Header>
        {type == 'small' && image && (
          <div className="d-flex" onClick={cardClick}>
            <div
              className="d-flex align-items-start flex-shrink-0 me-md-4 me-3 cursorPointer"
              onClick={cardClick}
            >
              <Card.Image>
                <LazyImage
                  src={image}
                  alt="banner"
                  fallback_image={clinical_Video_static_image}
                  className={`object-fit-cover w-100 h-100`}
                  extraClass="hover-image w-100 h-100 position-relative"
                />
              </Card.Image>
            </div>
          </div>
        )}

        {type !== 'small' && (
          <div
            ref={videoDetailsParent}
            style={{ height: `${aspectVideoContainerSize}px` }}
            onMouseEnter={handleVideoShow}
            onMouseLeave={handleVideoClose}
            onTouchMove={handleVideoShow}
            onClick={cardClick}
            className="cursorPointer"
          >
            <Card.Image>
              {/* on hover "loadPlayer" card.image */}
              {!videoRendered && image && (
                <>
                  <LazyImage
                    src={image}
                    alt="banner"
                    fallback_image={clinical_Video_static_image}
                    className={`object-fit-cover w-100 h-100`}
                  />
                  <div className="overlay">
                    <div className="position-absolute translate-middle start-50 top-50 playIconAnimation">
                      <i className="flaticon-play text-white position-absolute translate-middle start-50 top-50 z-1"></i>
                    </div>
                  </div>
                </>
              )}
              {showVideo && src && (
                <div className="w-100 h-100 cursorPointer">
                  <ReactPlayer
                    ref={playerRef}
                    onReady={onReady}
                    onStart={handleStart}
                    url={src}
                    playing={true}
                    controls={false}
                    width={'100%'}
                    height={'100%'}
                    muted={true}
                    playsinline={true}
                  />
                </div>
              )}
              {loading && (
                <div className="overlay">
                  <div className="position-absolute translate-middle start-50 top-50 playIconAnimation">
                    <i className="flaticon-play text-white position-absolute translate-middle start-50 top-50 z-1"></i>
                  </div>
                </div>
              )}

              <div className="position-absolute top-0 text-white start-0 w-100 h-100 z-3 d-flex flex-column justify-content-between clr_v3_card__clinicalVideos__content">
                <div className="effect-out-top px-sm-4 px-3 pb-sm-4 pb-3">
                  {sessionDoctorDetails && <SpeakerDoc data={sessionDoctorDetails} />}
                </div>
                {question && (
                  <div className="effect-out-bottom d-flex justify-content-center flex-column cursorPointer px-sm-4 px-3 py-sm-4 py-3">
                    <Card.Title className="hover-opacity text-white">
                      {removeHtmlTags(question)}
                    </Card.Title>
                  </div>
                )}
              </div>
            </Card.Image>
          </div>
        )}
        <Card.Footer>
          <div className="me-auto d-flex align-items-center flex-grow-1">
            <span
              className="clr_v3_card__icon opacity-50 text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center"
              onClick={onLikePress}
            >
              <i class="flaticon-heart-1 me-2 fs-2"></i>
              {<span>{likeCount ?? 0}</span>}
            </span>
            <span
              className="clr_v3_card__icon opacity-50 text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center cursorPointer"
              onClick={cardClick}
            >
              <i class="flaticon-oval-black-speech-bubble me-2 fs-2"></i>
              {/* {<span>{commentCount ?? 0}</span>} */}
            </span>
            {/* <span className="clr_v3_card__icon opacity-50 text-dark py-1 d-inline-flex align-items-center justify-content-center">
              <i class="flaticon-eye me-2 fs-2"></i>
              {<span>{viewCount ?? 0}</span>}
            </span> */}
          </div>

          {sponsor_logo && sponsor_logo?.length > 0 ? (
            <Swiper
              className="clr_v3_sponsor text-right me-0"
              navigation={false}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 2500
              }}
              effect={'fade'}
            >
              {sponsor_logo &&
                sponsor_logo?.length > 1 &&
                sponsor_logo?.map((_sp, idx) => (
                  <SwiperSlide
                    key={idx + 1}
                    className="clr_v3_sponsor_slide w-100 position-relative"
                  >
                    <LazyImage
                      src={_sp}
                      alt="sponsor"
                      className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                      logo
                    />
                  </SwiperSlide>
                ))}
              {sponsor_logo &&
                sponsor_logo?.length == 1 &&
                sponsor_logo?.map((_sp, idx) => (
                  <div
                    // key={idx + 1}
                    className="clr_v3_sponsor_slide w-100 position-relative"
                  >
                    <LazyImage
                      src={sponsor_logo[0]}
                      alt="sponsor"
                      className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                      logo
                    />
                  </div>
                ))}
            </Swiper>
          ) : (
            <div className="clr_v3_sponsor_slide w-100 position-relative"></div>
          )}
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};

ClinicalVideosCard.propTypes = propTypes;
ClinicalVideosCard.defaultProps = defaultProps;
// #endregion

export default memo(ClinicalVideosCard);
